export default function RefreshIcon(props) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 12C17.3438 12 12 17.3438 12 24C12 25.5938 12.2812 27.0938 12.8438 28.5C13.2188 29.25 12.9375 30 12.375 30.5625C11.4375 31.5938 9.65625 31.2188 9.09375 29.9062C8.4375 28.125 7.96875 26.0625 7.96875 24C7.96875 15.1875 15.1875 7.96875 24 7.96875V4.40625C24 3.5625 25.125 3.09375 25.6875 3.65625L31.3125 9.28125C31.6875 9.65625 31.6875 10.3125 31.3125 10.6875L25.6875 16.3125C25.125 16.875 24 16.5 24 15.5625V12ZM35.625 17.4375C36.5625 16.4062 38.3438 16.7812 38.9062 18.0938C39.5625 19.875 40.0312 21.9375 40.0312 24C40.0312 32.8125 32.8125 40.0312 24 40.0312V43.5938C24 44.4375 22.875 44.9062 22.3125 44.3438L16.6875 38.7188C16.3125 38.3438 16.3125 37.6875 16.6875 37.3125L22.3125 31.6875C22.875 31.125 24 31.5 24 32.4375V36C30.6562 36 36 30.6562 36 24C36 22.4062 35.7188 20.9062 35.1562 19.5C34.7812 18.8438 35.0625 18 35.625 17.4375Z"
        fill="#FFB800"
      />
    </svg>
  );
}
